import { FC, ReactNode, useMemo } from 'react';

import useNeuladenBeimSeitenwechsel from '@/hooks/useNeuladenBeimSeitenwechsel';
import useVersionCheck from '@/hooks/useVersionCheck';
import { NeuerStandProvider } from '@/utils/context/NeuerStandContext';

/**
 * Versions-Check + Reload beim Seitenwechsel, EINMAL je Tab (Entscheid Alex
 * 27.10.2026, docs/tasks/auto-reload-neuer-stand.md).
 *
 * Haengt in `RootView`, nicht im Home-Layout: die Beratungsstrecke
 * (`/home/customers/customer/…`) liegt NEBEN dem Home-Layout. Hinge der Check
 * dort, wuerde er beim Wechsel in die Strecke abgebaut und saehe den
 * Seitenwechsel nie — der Reload bliebe still aus. Das Banner im Home-Layout
 * liest das Ergebnis ueber den Context, statt selbst zu messen.
 */
const NeuerStandWaechter: FC<{ children: ReactNode }> = ({ children }) => {
  const { updateAvailable, serverBuild } = useVersionCheck();
  useNeuladenBeimSeitenwechsel(serverBuild);

  const wert = useMemo(() => ({ updateAvailable }), [updateAvailable]);

  return <NeuerStandProvider value={wert}>{children}</NeuerStandProvider>;
};

export default NeuerStandWaechter;
